import { useState, useEffect } from "react";
import { deleteQnA, getConfigByID, getQuestion, InsertMandetoryQue, PublishConfig } from "../../Services/chatbot";
import { toast } from "react-toastify";
import { Tooltip, OverlayTrigger } from "../../../evo/bootstrap";
import DeleteModal from "../DeleteModal/index";
import { Modal, Button } from "../../../evo/bootstrap";
import "../../assets/chatbotconfig.css"
import QnAModal from "../QnAModal/index";
import DocumentManage from "../DocumentManage/index";
import Faq from "../Faq/index";
import { HelpCircle } from "lucide-react";
import { PageHeader } from "@/components/admin/cards";

// const Link = ({ id, children, title }) => (
//     <OverlayTrigger overlay={<Tooltip id={id}>{title}</Tooltip>}>
//         {children}
//     </OverlayTrigger>
// );
const Link = ({ id, children, title }: any) => (
    <OverlayTrigger overlay={<Tooltip id={id || 'tooltip'}>{title}</Tooltip>}>
        <span className="d-inline-block">{children}</span>
    </OverlayTrigger>
);

const MandetoryQue = ({ setPublishTrigger,setConfirmModal,setIsNeedPublish,isDirty, setIsDirty, shouldLoadQna, onLoaded }: any) => {
    const [shouldLoadDocument, setShouldLoadDocument] = useState(false);
    const [activeInnerTab, setActiveInnerTab] = useState("faq");

 
    const handleInnerTabChange = (newTab, e) => {
        if (e?.preventDefault) e.preventDefault();
      
        if (isDirty) {
          // Show the same modal you use for outer tabs
          setConfirmModal({
            show: true,
            title: "Unsaved Changes",
            label: "You have unsaved changes in this section. Do you want to leave without saving?",
            confirmText: "Leave Without Saving",
            cancelText: "Stay Here",
            onConfirm: () => {
              setConfirmModal({ show: false });
              setIsDirty(false); // ✅ Reset dirty state so we don’t ask again
              switchInnerTab(newTab);
            },
            onClose: () => {
              setConfirmModal({ show: false });
            }
          });
          return;
        }
      
        switchInnerTab(newTab);
      };
      
      const switchInnerTab = (newTab) => {
        setActiveInnerTab(newTab);
      
        if (newTab === "document") {
          setShouldLoadDocument(true);
        }
      
        if (newTab === "faq") {
          onLoaded(false);
          setTimeout(() => {
            onLoaded(true);
          }, 0);
        }
      };
      
    

    return (
        <div className="d-flex flex-column gap-4">
            <PageHeader id="faqHeading" icon={<HelpCircle />} title="FAQs"
                description="Questions guests often ask and the answers your chatbot gives." />
            <div className="tab-content" id="myTabContent">
                <div className={`tab-pane fade ${activeInnerTab === "faq" ? "show active" : ""}`}>
                    <Faq
                        setIsNeedPublish={setIsNeedPublish}
                        setIsDirty={setIsDirty}
                        shouldLoadQna={shouldLoadQna}
                        onLoaded={onLoaded}
                        isDirty={isDirty}
                        setPublishModal={setConfirmModal}
                        setPublishTrigger={setPublishTrigger}
                    />
                </div>
                <div className={`tab-pane fade ${activeInnerTab === "document" ? "show active" : ""}`}>
                    <DocumentManage
                        shouldLoadDocument={shouldLoadDocument}
                        onLoaded={() => setShouldLoadDocument(false)}
                    />
                </div>
            </div>
        </div>
    );
};



export default MandetoryQue;
